import { observer } from "mobx-react";
import React from "react";

export interface ToolBarType {
  children?: any;
  actions?: any;
}

export const Toolbar = observer(({ children, actions }: ToolBarType) => {
  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <div>{children}</div>
      <div>{actions}</div>
    </div>
  );
});
